__turbopack_context__.v({
  "className": "jetbrains_mono_20e41922-module__icFdYa__className",
  "variable": "jetbrains_mono_20e41922-module__icFdYa__variable",
});
